import { render, staticRenderFns } from "./MainShowMoreBtn.vue?vue&type=template&id=004d130e&scoped=true&"
import script from "./MainShowMoreBtn.vue?vue&type=script&lang=js&"
export * from "./MainShowMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./MainShowMoreBtn.vue?vue&type=style&index=0&id=004d130e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d130e",
  null
  
)

export default component.exports